import amadeus from './logos/amadeus.png';
import amadeusIcon from './logos/amadeus-icon.png';
import expedia from './logos/expedia.png';
import expediaIcon from './logos/expedia-icon.png';
import premierInn from './logos/premier-inn.png';
import premierInnIcon from './logos/premier-inn-icon.png';
import travelcube from './logos/travelcube.png';
import travelcubeIcon from './logos/travelcube-icon.png';
import travelodge from './logos/travelodge.png';
import travelodgeIcon from './logos/travelodge-icon.png';
import bookingCom from './logos/booking-com.jpg';
import bookingComIcon from './logos/booking-com-icon.jpg';
import unknown from './logos/unknown.png';
import unknownIcon from './logos/unknown-icon.png';

export default {
    amadeus,
    amadeusIcon,
    expedia,
    expediaIcon,
    premierInn,
    premierInnIcon,
    travelcube,
    travelcubeIcon,
    travelodge,
    travelodgeIcon,
    bookingCom,
    bookingComIcon,
    unknown,
    unknownIcon,
};



// WEBPACK FOOTER //
// ./src/app/modules/supplier/assets/logos.js